import React from "react";
import { Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import "./Join.scss";

const Join: React.FC = () => {
    return (
        <div className="join-page">
            <div className="content">
                <img
                    src="https://www.influenxio.com/static/images/landing/reason02.svg"
                    alt="Join"
                    className="illustration"
                />
                <Typography variant="h5" className="title">
                    Find opportunities and build your network
                </Typography>
                <Typography variant="body1" className="subtitle">
                    Join us to engage with top professionals, find new opportunities, and reach new
                    heights in your career.
                </Typography>
            </div>
            <div className="footer">
                <Button variant="contained" className="primary-btn">
                    Join MAX Aspire
                </Button>
                <Link to="" className="login-btn">
                    Log In
                </Link>
            </div>
        </div>
    );
};

export default Join;
